import(/* webpackMode: "eager" */ "/inner-circle/app/global-error.tsx")